<template>
  <li>
    <router-link :to="{ name: 'bookings.show', params: { id: booking.id } }">
      <h3>{{ booking.name }}</h3>

      <div class="row">
        <div class="col-xs-6">
          <p><i class="fa fa-map-marker fa-fw"></i> {{ bookingStateOrOnline | nullable }}</p>
        </div>
        <div class="col-xs-6">
          <p v-if="bookingAppearanceInPerson">
            <i class="fa fa-calendar fa-fw"></i>
            <span class="hidden-xs hidden-sm hidden-md">{{ bookingInPersonOpportunityName }} Event Date: </span>{{ dateUserTz | date($user.date_format_preference) | nullable }}
          </p>
          <p v-if="bookingAppearanceOnline">
            <i class="fa fa-globe fa-fw"></i>
            <span class="hidden-xs hidden-sm hidden-md">{{ bookingOnlineOpportunityName }} Due By: </span>{{ booking.complete_by_date | date($user.date_format_preference) | nullable }}
          </p>
        </div>
        <div class="col-xs-12">
          <p class="item-detail-talent-name"><i class="fa fa-user fa-fw"></i> {{ bookingBookedTalentNames }}</p>
        </div>
        <div class="col-xs-6">
          <p>{{ bookingClientCompanyAndName }}</p>
        </div>
      </div>
      <span class="price">
        <span class="amount">{{ booking.budget_per_star_as_user_rate | currency(booking.currency) }}</span>
      </span>
    </router-link>
  </li>
</template>

<script>
import { helpers } from 'mixins/bookings'
import moment from 'moment-timezone'

export default {
  mixins: [helpers],

  props: {
    booking: {
      required: true,
      type: Object
    }
  },

  computed: {
    dateUserTz () {
      return moment.utc(this.booking.utc_date).tz(this.$user.timezone)
    }
  }
}
</script>
